export default __webpack_public_path__ + "static/media/Fields_CFI2023_poster.ec9d0db3.pdf";